import React from 'react';
import AsyncPage from './async';
import DefaultConsumerLayout from '../../../../components/layout/DefaultConsumerLayout';

export default [
  <DefaultConsumerLayout
    key="/consumer/features/photo-effects"
    exact
    path="/consumer/features/photo-effects"
    component={AsyncPage}
  />,
];
